
import { useState, useCallback } from 'react';
import { toast } from 'sonner';
import { type EnhancedCrawlResult } from '@/types/crawler';

export function useComparisonState() {
  const [compareMode, setCompareMode] = useState<boolean>(false);
  const [comparisonResult, setComparisonResult] = useState(null);

  const compareWithHistory = useCallback((url: string, currentResult: EnhancedCrawlResult) => {
    toast.info('Historical comparison feature has been removed');
  }, []);

  const clearComparison = useCallback(() => {
    setCompareMode(false);
    setComparisonResult(null);
  }, []);

  return {
    compareMode,
    comparisonResult,
    compareWithHistory,
    clearComparison
  };
}
